import { getAwsAssets } from "@src/utils";
import Image from "@src/lib/Image";

function SuccessIdfyDoc({ setIsSuccessDoc }) {
  const handleButtonClick = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("idfySuccessDoc", "false");
      setIsSuccessDoc(false);
    }
  };
  return (
    <div className="idfy-prepurchage">
      <div className="success-doc">
        <div className="verification-logo">
          <Image
            src={getAwsAssets("CouponSuccess.gif", "Overview")}
            alt="idfys"
            width={80}
            height={80}
          />
        </div>
        <h2 className="postpurchage-itle">Verified Successfully</h2>
        <p className="postpurchage-description">
          Your Aadhaar is verified successfully. You can start learning now
        </p>
        <div className="btn-box">
          <button onClick={handleButtonClick} className="button-click">
            DONE
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessIdfyDoc;
